const ResumeTimerSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.125 5.724C6.125 5.36604 6.125 5.18705 6.19981 5.08713C6.265 5.00006 6.36478 4.94558 6.47328 4.93783C6.59779 4.92893 6.74834 5.02572 7.04945 5.21929L10.5899 7.49529C10.8512 7.66326 10.9818 7.74725 11.027 7.85404C11.0664 7.94735 11.0664 8.05265 11.027 8.14596C10.9818 8.25275 10.8512 8.33674 10.5899 8.50471L7.04946 10.7807C6.74834 10.9743 6.59779 11.0711 6.47328 11.0622C6.36478 11.0544 6.265 10.9999 6.19981 10.9129C6.125 10.8129 6.125 10.634 6.125 10.276V5.724Z"
      stroke="#1369E9"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.25 4.85C1.25 3.58988 1.25 2.95982 1.49524 2.47852C1.71095 2.05516 2.05516 1.71095 2.47852 1.49524C2.95982 1.25 3.58988 1.25 4.85 1.25H11.15C12.4101 1.25 13.0402 1.25 13.5215 1.49524C13.9448 1.71095 14.289 2.05516 14.5048 2.47852C14.75 2.95982 14.75 3.58988 14.75 4.85V11.15C14.75 12.4101 14.75 13.0402 14.5048 13.5215C14.289 13.9448 13.9448 14.289 13.5215 14.5048C13.0402 14.75 12.4101 14.75 11.15 14.75H4.85C3.58988 14.75 2.95982 14.75 2.47852 14.5048C2.05516 14.289 1.71095 13.9448 1.49524 13.5215C1.25 13.0402 1.25 12.4101 1.25 11.15V4.85Z"
      stroke="#1369E9"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ResumeTimerSvg;
